<svg:foreignObject [attr.x]="block.x" [attr.y]="block.finalY" [attr.width]="block.width" [attr.height]="block.height" overflow="visible">
    <xhtml:div class="block d-flex align-items-center">
        <div class="text-truncate" [ngbTooltip]="block.name" triggers="manual" libTooltipWhenOverflow position="top" container="body">
            <span>{{ block.name }}</span>
        </div>
    </xhtml:div>
</svg:foreignObject>
